import React, { useState } from 'react'
import { apiMesAJsMonth, MONTHS_ES } from './Mes';
import { EVENT_COLORS } from './EventColors';
import SettingsIcon from '@mui/icons-material/Settings';
import ModalOptionsWithSub from './ModalOptionsWithSub';


const ListadoJustificaciones = ({ data, getOpciones }) => {

    const [openOptionsFolio, setOpenOptionsFolio] = useState(null);

    const colorPorSucursal = (idsucursal) =>
        EVENT_COLORS[idsucursal % EVENT_COLORS.length];


    return (
        <div className="pa-list-view scroll">

            {/* ── Header de columnas ── */}
            <div className="pa-list-header">
                <div className="pa-list-header__fecha">Fecha</div>
                {/* <div className="pa-list-header__dot" /> */}
                <div className="pa-list-header__info borde-izq">Sucursal / Folio</div>
                <div className="pa-list-header__auditor borde-izq">Auditor principal</div>
                {/* <div className="pa-list-header__estatus">estatus</div> */}
                <div className="pa-list-header__metric borde-izq">Diferencias</div>
                <div className="pa-list-header__metric borde-izq">Justificadas</div>
                <div className="pa-list-header__metric borde-izq">No justificadas</div>
                <div className="pa-list-header__metric borde-izq">Aceptadas</div>
                <div className="pa-list-header__metric borde-izq">Rechazadas</div>
                <div className="pa-list-header__estatus borde-izq">Fecha limite</div>

                {/* <div className="pa-list-header__metric">Avance</div> */}
                <div className="pa-list-header__actions" />      {/* spacer del engranaje */}
            </div>

            {data.length === 0 ? (
                <div className="pa-list-empty">
                    Sin inventarios programados.
                </div>
            ) : (
                data.map((ev, idx) => {
                    const c = colorPorSucursal(ev.idsucursal);
                    return (
                        <div
                            key={`${ev.folio}-${idx}`}
                            className="pa-list-row"
                            style={{ borderLeftColor: c.bg }}
                        >
                            {/* Fecha */}
                            <div className="pa-list-row__date">
                                <span className="pa-list-row__day">{String(ev.dia).padStart(2, "0")}</span>
                                <span className="pa-list-row__month">{MONTHS_ES[apiMesAJsMonth(ev.mes)].slice(0, 3)}</span>
                            </div>

                            {/* Dot color sucursal */}
                            {/* <div className="pa-list-row__dot" style={{ background: c.bg }} /> */}

                            {/* Sucursal / Folio */}
                            <div className="pa-list-row__info">
                                <span className="pa-list-row__id">{ev.sucursal} | {ev.folio}</span>
                                <span className="pa-list-row__tipo">{ev.fecha_inicio} - {ev.fecha_fin}</span>
                            </div>

                            {/* Auditor */}
                            <div className="pa-list-row__auditor">
                                <div className="pa-list-row__avatar-wrap">
                                    <div
                                        className="pa-list-row__avatar"
                                        style={{ background: c.bg }}
                                        title={ev.auditor_ppal}
                                    >
                                        {ev.auditor_ppal?.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase()}
                                    </div>
                                    <span className="pa-list-row__auditor-name">{ev.auditor_ppal}</span>
                                </div>
                            </div>

                            {/* Diferencias */}
                            <div className="pa-list-row__metric">
                                <span className={`pa-metric-badge pa-metric-badge--${ev.diferencias !== 0 ? "warn" : "ok"}`}>
                                    {ev.diferencias}
                                </span>
                            </div>


                            {/* Justificadas */}
                            <div className="pa-list-row__metric">
                                <span className={`pa-metric-badge pa-metric-badge--${ev.justificadas !== 0 ? "ok" : "ok"}`}>
                                    {ev.justificadas}
                                </span>
                            </div>

                            {/* No Justificadas */}
                            <div className="pa-list-row__metric">
                                <span className={`pa-metric-badge pa-metric-badge--${ev.no_justificadas !== 0 ? "warn" : "warn"}`}>
                                    {ev.no_justificadas}
                                </span>
                            </div>

                            {/* Aceptadas */}
                            <div className="pa-list-row__metric">
                                <span className={`pa-metric-badge pa-metric-badge--${ev.aceptadas !== 0 ? "ok" : "ok"}`}>
                                    {ev.aceptadas}
                                </span>
                            </div>

                            {/* Rechazadas */}
                            <div className="pa-list-row__metric">
                                <span className={`pa-metric-badge pa-metric-badge--${ev.rechazadas !== 0 ? "warn" : "warn"}`}>
                                    {ev.rechazadas}
                                </span>
                            </div>

                            <div className="pa-list-row__estatus">
                                <span
                                    className="pa-estatus-badge"
                                >
                                    {ev.fecha_justificacion}
                                </span>

                            </div>

                            {/* Opciones */}
                            <div className="pa-list-settings-wrap">
                                <span
                                    className="pa-settings-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenOptionsFolio(openOptionsFolio === ev.folio ? null : ev.folio);
                                    }}
                                >
                                    <SettingsIcon />
                                </span>
                                {openOptionsFolio === ev.folio && (
                                    <ModalOptionsWithSub
                                        onClose={() => setOpenOptionsFolio(null)}
                                        options={getOpciones(ev)}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    )
}

export default ListadoJustificaciones
